'use strict';

// file-dropzone/drag.js — делегированная обработка drag-and-drop на дропзоне

let prevent = function (e) { e.preventDefault(); e.stopPropagation(); };

jQuery(document)
    .on('dragenter', '.file-dropzone', function (e) {
        prevent(e);
        jQuery(this).addClass('is-dragover');
    })
    .on('dragover', '.file-dropzone', function (e) {
        prevent(e);
    })
    .on('dragleave', '.file-dropzone', function (e) {
        prevent(e);
        jQuery(this).removeClass('is-dragover');
    })
    .on('drop', '.file-dropzone', function (e) {
        prevent(e);
        let dropzone = jQuery(this);
        dropzone.removeClass('is-dragover');

        let files = Array.from(
            (e.originalEvent && e.originalEvent.dataTransfer && e.originalEvent.dataTransfer.files) || []
        );
        if (!files.length) return;

        // Любой file-инпут внутри зоны: .file-dropzone-input (file-dropzone) или .image-upload-input (image-upload).
        let fileInput = dropzone.find('input[type=file]').first();
        if (!fileInput.length) return;

        let dt = new DataTransfer();
        files.forEach(function (f) { dt.items.add(f); });
        fileInput[0].files = dt.files;
        fileInput.trigger('change');
    });